// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "flowbite/dist/flowbite.turbo.js"
import "trix"
import "@rails/actiontext"

function updateTrixToolbarVisibility() {
    document.querySelectorAll("trix-editor").forEach(function(editorElement) {
        var toolbarElement = editorElement.toolbarElement;
        if (editorElement == document.activeElement) {
            toolbarElement.style.display = "";
        } else {
            if (!toolbarElement.contains(document.activeElement)) {
                toolbarElement.style.display = "none";
            }
        }
    });
}
